import { createSlice } from "@reduxjs/toolkit";

type StateType = {
  route: any;
  date: string;
  journey: null;
};

const initialState: StateType = {
  route: null,
  date: "",
  journey: null,
};

const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    updateRoute(state, action) {
      state.route = action.payload;
    },
    updateDate(state, action) {
      state.date = action.payload;
    },
    updateJourney(state, action) {
      state.journey = action.payload;
    },
    resetBooking(state) {
      state.route = null;
      state.date = "";
      state.journey = null;
    },
  },
});

export const { updateRoute, updateDate, resetBooking } = bookingSlice.actions;
export default bookingSlice.reducer;
